/* eslint-disable import/prefer-default-export */
export enum Language {
  EN,
  FR,
  DE,
  IT,
  RU,
  ES,
}
